/* eslint-disable react/no-danger */
import { NotificationContext } from 'app/contexts/notification/notification.context'
import { MessageType } from 'app/contexts/notification/notification.reducer'
import React, { useCallback, useEffect, useState } from 'react'
import { Notification } from 'react-rainbow-components'

type Props = {
  children: React.ReactNode
}

type NotificationObject = {
  isOpen: boolean
  title: string
  message: string
  type: MessageType
}

const NotificationProvider2 = ({ children }: Props) => {
  const [notification, setNotification] = useState<NotificationObject>({
    isOpen: false,
    title: '',
    message: '',
    type: MessageType.success,
  })
  const { isOpen, title, message, type } = notification

  const onOpen = (
    titleNotification: string,
    messageNotification: string,
    typeNotification: MessageType
  ) => {
    setNotification({
      isOpen: true,
      title: titleNotification,
      message: messageNotification,
      type: typeNotification,
    })
  }

  const onClose = useCallback(() => {
    setNotification({ ...notification, isOpen: false })
  }, [notification])

  useEffect(() => {
    if (isOpen) {
      setTimeout(onClose, 5000)
    }
  }, [isOpen, onClose])

  const message2 = (
    <div
      style={{ fontSize: 13, color: 'black' }}
      dangerouslySetInnerHTML={{ __html: message }}
    />
  )

  return (
    <NotificationContext.Provider value={{ onOpen, onClose }}>
      {children}
      {isOpen && (
        <Notification
          title={title}
          description={
            message?.length > 80 ? (
              <div
                style={{
                  fontSize: '12.5px',
                  color: '#4a4a4a',
                  marginTop: 2,
                  fontFamily: 'sans-serif',
                  overflowWrap: 'break-word',
                  wordBreak: 'break-all',
                  whiteSpace: 'pre-line',
                  hyphens: 'auto',
                }}
                dangerouslySetInnerHTML={{
                  __html: message.replaceAll('\n', '<br />'),
                }}
              />
            ) : (
              message
            )
          }
          icon={type}
          onRequestClose={onClose}
          style={{
            position: 'fixed',
            top: 10,
            right: 10,
            height: 'auto',
            maxHeight: `${message?.length > 70 ? '125px' : '85px'}`,
            zIndex: 9999,
            width: `${message?.length > 71 ? '360px' : '310px'}`,
          }}
        />
      )}
    </NotificationContext.Provider>
  )
}
export default NotificationProvider2
